interface StateType {
    mainBackground: string;
    topBackground: string;
    bottomBackground: string;
    listBackground: string;
    boxBackground: string;
    receiveBtn: string;
    tab1: string;
    tab2: string;
    tab3: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        tab1: '',
        tab2: '',
        tab3: '',
        mainBackground: '',
        topBackground: '',
        bottomBackground: '',
        listBackground: '',
        boxBackground: '',
        receiveBtn: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
